import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { policies, policiesNotice } from "../data/policies";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

export default function PoliciesPage() {
  useTitle("Policies | HairByYaya");

  return (
    <div className="px-5 pb-24 pt-28 md:pt-36" data-testid="policies-page">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <p className="font-script text-3xl text-hotpink">good to know</p>
          <h1 className="mt-2 font-serif text-4xl md:text-6xl">Policies</h1>
        </Reveal>

        <Reveal className="mt-8 flex items-start gap-3 rounded-2xl border border-hotpink/40 bg-hotpink/10 p-5">
          <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-hotpink" />
          <p className="text-sm leading-relaxed text-white/75">
            {policiesNotice}
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {policies.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.08}>
              <article className="h-full rounded-2xl border border-white/10 bg-coal p-7 transition-colors duration-300 hover:border-hotpink/40">
                <h2 className="font-serif text-xl">{p.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-white/55">
                  {p.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14 text-center">
          <p className="text-sm text-white/55">
            Ready when you are — read the policies, pick your style, and lock in
            your look.
          </p>
          <Link
            to="/book"
            data-testid="policies-book-now"
            className="mt-6 inline-block rounded-full bg-hotpink px-9 py-4 text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-magenta"
          >
            Book Now
          </Link>
        </Reveal>
      </div>
    </div>
  );
}

